import _ from 'lodash';
import {
  imageMode,
  AD_TYPE,
  NORMAL_AD_SOURCES,
  NATIVE_AD_ACTION_TYPE,
  DISCLAIMER_TYPES,
  CARD_ADDITIONAL_CREATIVE_TYPE,
  ADDITIONAL_CREATIVE_IMAGE_CARD_TEMPLATE_TYPES,
  ADDITIONAL_CREATIVE_ATTACHMENT_EXPERIENCE_TYPES,
  DARK_POST_STATUS_MAP,
} from 'src/const/state/creative';
// import { ADVANCED_CREATIVE_TYPE, TTCallToAction } from 'src/const/state/call-to-action';
import { TTCallToAction, ADVANCED_CREATIVE_TYPE } from 'src/const/state/call-to-action';

const {
  IMAGE_CARD: ADDITION_IMAGE_CARD,
  INSTANT_PAGE: ADDITION_INSTANT_PAGE,
} = ADDITIONAL_CREATIVE_ATTACHMENT_EXPERIENCE_TYPES;

const {
  SINGLE_IMAGE, SINGLE_VIDEO, CATALOGUE_VIDEO, CATALOGUE_IMAGE, CAROUSEL_IMAGE, REAL_TIME_LIVE,
} = AD_TYPE;
const { CREATE_NEW, NATIVE_VIDEO } = NORMAL_AD_SOURCES;

const DISCLAIMER_DATA = {
  disclaimer_type: DISCLAIMER_TYPES.UN_SET,
  disclaimer_text: { text: '' },
  disclaimer_clickable_texts: [],
};

const SINGLE_VIDEO_TEMPLATE = {
  title: '',
  creative_name: '',
  call_to_action: '',
  autoCreativeName: true,

  is_creative_authorized: false, // 创意素材授权

  app_name: '', // appinstall下沉字段
  source: '', // 应用的展示名称(diaplayName)字段是app_name，落地页是source
  open_url: '',
  external_url: '',
  is_open_url: 0,
  fallback_type: 0,

  avatar_icon: {
    width: 180,
    web_uri: '',
    height: 180,
    url: '',
  },
  page_id: '',
  auto_open: 0,
  track_url: [],
  action_track_url: [],
  brand_safety_postbid_partner: 0, // zefr开关
  brand_safety_vast_url: '', // BS IAS URL
  vast_moat: 0,
  vast_double_verify: 0,
  vast_ias: false,
  vast_url: '',
  enableUrl: false,
  // advanced_creative_type: ADVANCED_CREATIVE_TYPE.customization, // CTA类型，下拉框，还是文案优选集（程序根据模型计算CTA的选项）
  call_to_action_id: '', // CTA 文案优选集的 id
  call_to_action_type: ADVANCED_CREATIVE_TYPE.default, // 默认选中default
  isQuickOptimizeToolsShow: false, // 是否展示一键优化抽屉
  quickOptimizeToolInfo: {}, // 一键优化信息
  isUseAutoGenerateCreativeName: false,
  format_structure: CARD_ADDITIONAL_CREATIVE_TYPE.CUSTOMIZED.value, // 附加创意类型,
  identity_type: 0, // identity账号类型
  identity_id: '', // identity账号Id
  identity_data: {}, // identity头像和显示名称
  available_status: 0,
  can_use_live_list: true,
  can_use_video_list: true,
  domain: '',
  gesture_id: '',
  painted_egg_id: '',
  ...DISCLAIMER_DATA,
  creative_type: '',
  isSignProtocol: false,
  isCheckedMusicProtocol: true, // 纯前端字段 是否同意音乐合规协议
  dark_post_status: DARK_POST_STATUS_MAP.OFF, // 暗投模式。默认不勾选
};
/**
 * 选择创建 additional creative 创意（卡片, 轻落地页)时增加的参数
 */
export const ADDITIONAL_CREATIVE_PARAMS = {
  cardAdditionalInfo: {
    [ADDITION_IMAGE_CARD]: {
      isChecked: false,
      mode: ADDITIONAL_CREATIVE_IMAGE_CARD_TEMPLATE_TYPES.CUSTOMIZED_IMAGE.value,
    },
    [ADDITION_INSTANT_PAGE]: {
      isSelected: false,
      mode: '',
    },
  },
  loadingStorefrontDetail: false, // 是否在加载 page 信息
  product_platform_id: '', // 编辑器选择的商品库 id
  product_set_id: '', // 编辑器选择的商品序列 id
  dpa_products: [], // 编辑器中排序指定的商品
  dpa_preview_products: [], // 用于预览的商品，由指定的商品和额外获取的商品组成
  page_product_configuration: '', // 预览时展示的商品卡片样式配置
  page_preview_url: '', // PLP 页面预览地址
  page_image_url: '', // PLP image card 地址
  page_card_format: '', // PLP 的卡片类型 0 gallery 1 image card
  creative_shop_id: '', // creative保存的shopId，用于前端判断是否修改
  // TODO：将 CA 字段统一到 page info 管理
  collectionAdsPageInfo: {}, // Collection Ads 的 page 信息
};

const SPU = {
  selectedSpuMap: {}, // spu Map
  isShopHasUnavailablePrd: false, // shop vsa存在不可用的已选商品（阻断提交）
  spu_list: [],
};

// 单个ad的默认值。 每个创意可以同时设置多种来源，每个来源下又有多种形式，提交到后端时只使用当前选中来源+形式的素材
export const TEMPLATE = {
  // 使用create new方式新建广告
  [CREATE_NEW.value]: {
    [SINGLE_IMAGE.value]: { // 单图片创意
      title: '',
      creative_name: '',
      // advanced_creative_type: ADVANCED_CREATIVE_TYPE.customization,
      call_to_action: '',
      call_to_action_id: '',
      call_to_action_type: ADVANCED_CREATIVE_TYPE.default, // 默认选中default
      autoCreativeName: true,
      app_name: '', // appinstall下沉字段
      source: '', // 应用的展示名称(diaplayName)字段是app_name，落地页是source
      open_url: '',
      external_url: '',
      is_open_url: 0,
      fallback_type: 0,
      domain: '',
      avatar_icon: {
        width: 180,
        web_uri: '',
        height: 180,
        url: '',
      },
      auto_open: 0,
      track_url: [],
      action_track_url: [],
      page_id: '',
      vast_moat: 0,
      vast_double_verify: 0,
      vast_ias: false,
      vast_url: '',
      isUseAutoGenerateCreativeName: false,
      identity_type: 0, // identity账号类型
      identity_id: '', // identity账号Id
      identity_data: {}, // identity头像和显示名称
      ...DISCLAIMER_DATA,
    },
    [SINGLE_VIDEO.value]: _.cloneDeep({ // 单视频创意
      ...SINGLE_VIDEO_TEMPLATE,
      ...ADDITIONAL_CREATIVE_PARAMS,
    }),
    [CATALOGUE_VIDEO.value]: { // 商品库视频创意
      title: '',
      creative_name: '',
      // advanced_creative_type: ADVANCED_CREATIVE_TYPE.customization,
      call_to_action: '',
      call_to_action_id: '',
      call_to_action_type: ADVANCED_CREATIVE_TYPE.default,
      autoCreativeName: true,
      app_name: '', // appinstall下沉字段
      source: '', // 应用的展示名称(diaplayName)字段是app_name，落地页是source
      open_url: '',
      external_url: '',
      dpa_open_url_type: 0,
      is_open_url: 0,
      fallback_type: 0,
      params_type: 0,
      domain: '',
      avatar_icon: {
        width: 180,
        web_uri: '',
        height: 180,
        url: '',
      },
      track_url: [],
      action_track_url: [],
      auto_open: 0,
      image_mode: imageMode.VIDEO_TYPE_3, // 固定写死，会预先将商品视频全部派生为竖版视频
      image_info: [], // 固定写死
      video_info: {}, // 固定写死
      dpa_word_set: [], // 动态词包id
      video_tpl_name: '', // 用户指定视频包ID
      video_display_mode: 1, // 视频包展示模式 1自动优选 2指定视频包
      identity_type: 0, // identity账号类型
      identity_id: '', // identity账号Id
      identity_data: {}, // identity头像和显示名称
      ...ADDITIONAL_CREATIVE_PARAMS,
    },
    [CATALOGUE_IMAGE.value]: { // 商品库图片创意
      title: '',
      creative_name: '',
      domain: '',
      // advanced_creative_type: ADVANCED_CREATIVE_TYPE.customization,
      call_to_action: '',
      call_to_action_id: '',
      call_to_action_type: ADVANCED_CREATIVE_TYPE.default, // 默认选中default
      autoCreativeName: true,
      image_mode: imageMode.IMAGE_I18N_SQUARE, // 固定写死竖图
      image_info: [], // 固定写死
      dpa_word_set: [], // 动态词包id
      identity_type: 0, // identity账号类型
      identity_id: '', // identity账号Id
      identity_data: {}, // identity头像和显示名称
      external_url: '',
      params_type: 0,
    },
    [CAROUSEL_IMAGE.value]: { // 多图轮播创意
      title: '',
      creative_name: '',
      // advanced_creative_type: ADVANCED_CREATIVE_TYPE.customization,
      call_to_action: '',
      autoCreativeName: true,
      app_name: '', // appinstall下沉字段
      open_url: '',
      is_open_url: 0,
      domain: '',
      avatar_icon: {
        width: 180,
        web_uri: '',
        height: 180,
        url: '',
      },
      auto_open: 0,
      track_url: [],
      action_track_url: [],
      vast_moat: 0,
      vast_double_verify: 0,
      vast_ias: false,
      vast_url: '',
      image_mode: imageMode.CAROUSEL_IMAGE_SQUARE,
      activeCarouselImageIndex: 0, // 当前激活的图片Index
      rejectImageIds: [], // 被拒审的图片ID列表
      carouselImageInfoComponentsNameList: [], // 当前轮播表单允许出现的表单项名称列表
      carouselImageModeChangerLoadingStatus: false,
      isUseAutoGenerateCreativeName: false,
      identity_type: 0, // identity账号类型
      identity_id: '', // identity账号Id
      identity_data: {}, // identity头像和显示名称
    },
    adType: '', // 当前选中形式
  },
  // 原生视频广告
  [NATIVE_VIDEO.value]: {
    // [SINGLE_VIDEO.value]: _.cloneDeep(SINGLE_VIDEO_TEMPLATE), // 单视频创意
    [SINGLE_VIDEO.value]: _.cloneDeep({
      with_promotional_music: true, // 是否打开推广音乐开关 false: 打开 true: 关闭
      item_duet_disabled: 2, // 是否开启合拍: 0-允许合拍，2-禁止合拍
      item_stitch_disabled: 2, // 是否开启跟拍：0-允许跟拍，2-禁止跟拍
      song_authorization_missing: false, // 音乐版权是否校验通过
      nativeAdActionType: NATIVE_AD_ACTION_TYPE.PULL_TT_POST, // 原生广告默认行为 拉视频
      identity_bc_id: '', // bc授权identity账号
      ...SINGLE_VIDEO_TEMPLATE,
      ...SPU, // shop monetization的spu相关字段
    }), // 单视频创意
    [REAL_TIME_LIVE.value]: _.cloneDeep({ // 实时直播创意
      ...SINGLE_VIDEO_TEMPLATE,
      image_mode: imageMode.REAL_TIME_LIVE,
      nativeAdActionType: NATIVE_AD_ACTION_TYPE.REAL_TIME_LIVE, // 直投直播间要求item_source是2
    }),
    adType: SINGLE_VIDEO.value, // 当前选中形式
  },
  adSource: CREATE_NEW.value, // 来源，create new或原生视频, 默认create new
};

export const SPLIT_TEST_UNIT = [TEMPLATE]; // 每个split test对照组，每个组可以包含若干个ad

export const INIT_ADS = [
  _.cloneDeep(SPLIT_TEST_UNIT), // 默认非split test，只有一个对照组
];

export default {
  ads: _.cloneDeep(INIT_ADS),
  videoRenderInfoList: [
    // split AB Test
    {
      taskList: [],
    },
    {
      taskList: [],
    },
  ],
  activeSplitTestTab: 0, // 激活的对照组索引
  options: TTCallToAction,
  appTypes: [0], // ad group层级所选的版位, 0表示通投，参考INVENTORY_FLOW
  sha1Key: '',
  dpaWordList: [], // DPA广告所选商品目录下的所有动态词包
  copyNumber: 0, // 创意复制的个数
  isNewStructure: false, // 是否是新结构下的创意
  appInfo: {},
  creativePreviewIndex: 0,
  selectedFormObject: {},
  selectedFormObjectOppo: {}, // split-test对照对象——tabB
  selectedForm: 0,
  shouldQcOptimizeToolsTipsShow: false, // 是否展示一键优化名词解释卡片
  precheckSuggestions: {}, // 素材预校验返回的机审结果
  precheckSummary: [], // 素材预校验机审汇总结果，展示在弹窗
  realTimePrecheckSuggtions: [], // 实时预校验的结果放在这里，等待预校验接口返回后放入precheckSuggestions中
  hasIntoAd: false, // 是否进入过ad层级
  isNoVideoPkgWarnTipShow: false, // 是否显示无视频包提示
  isCurrentProductSetCannotPreview: false, // 是否展示当前商品无预览视频提示
  isProductSetNoProduct: false, // 商品库商品是否为空
  isChangeVideoPkgBtnLoading: false, // 是否展示当前商品无预览视频提示
  showProtocolTerms: false, // 是否展示协议签署
  loadingPromotionDetail: false, // 加载 promotion type 中使用的相关信息
  bindAccountData: {}, // 绑定TTBA账号信息
  identityAuthorizationState: 0, // identity账号的授权状态
  supportBsZefrCountryList: [], // bs zefr支持的国家。
  supportBsIasCountryList: [], // bs ias支持的国家。
  supportBsDvCountryList: [], // bs dv支持的国家。
  shopAuthorizationState: 0, // shop的权限校验
  shopAuthorizationChecking: true, // shop校验中, 默认值为0，表示未校验
  shopAdsHasPermission: true, // shop creative有shop权限
  shopProductsNumIsValid: true, // shop vsa编辑场景下商品数是否达标
  hasZefrAuthority: false, // 是否有zefr的授权
  hasBsIasAuthority: false, // 是否有BS IAS的授权
  hasBsDvAuthority: false, // 是否有BS IAS的授权
  externalUrlDomain: { // 兼容split test场景
    0: [],
    1: [],
  },
  domainCancelToken: '',
  hasLeadAds: true, // 是否已创建过 Lead Ads 广告
  isShopAdLiveScenario: false,
  creatives: [], // ad下已实现创意列表
  fromLibraryVid: [], // 素材库选择的id
  fromLibraryPageId: [], // 素材库选择 instant page id
  fromLibraryCardId: [], // 素材库选择的 card id
  identityEmpty: false, // identity 是否为空
};
